import { State } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineStateSchema,
} from '../types';
import { getStateKey } from './getStateKey';
import { getStates } from './getStates';

type IsFinalState = (
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
) => boolean;

export const isFinalState: IsFinalState = state => {
  const states = getStates(state.context);
  const stateKey = getStateKey(state.value);
  return states.indexOf(stateKey) === states.length - 1;
};
